export default {
  namespaced: true,
  state: {
    activeIndex: 0,
    activeSubIndex: 0,
    openedIndex: 0
  },
  mutations: {
    SET_ACTIVE_INDEX(state, index) {
      state.activeIndex = index;
    },
    SET_ACTIVE_SUB_INDEX(state, { parentIndex, subIndex }) {
      state.activeIndex = parentIndex;
      state.activeSubIndex = subIndex;
    },
    SET_OPENED_INDEX(state, index) {
      state.openedIndex = index;
    },
    RESET_STATE(state) {
      state.activeIndex = null;
      state.activeSubIndex = null;
      state.openedIndex = null;
    }
  }
};